import axios from 'axios';

import { publishApiToNewRelic } from './newRelic';
import { MAX_VANTAGE_RETRIES, INVENTORY_AVAILABILITY_URL } from './constants';

// There's an issue with Vantage sometimes failing for fun right now (Sept. 15, 2022)
// Once we have an actual fix (or a stronger bandaid), we should remove/repurpose this method.
function isVantageError(error) {
  return error.response && error.response.status === 500 && error.response.data === 'Error retrieving Vantage token';
}

async function retryCallOnVantageError(call, maxRetries = MAX_VANTAGE_RETRIES) {
  let retries = 0;
  while (true) {
    try {
      // eslint-disable-next-line no-await-in-loop
      return await call();
    } catch (error) {
      if (isVantageError(error) && retries < maxRetries) {
        retries += 1;
      } else throw error;
    }
  }
}

async function getCurrentInventory({
  host,
  rentalCategory,
  rentalSubCategory,
  storeList
}) {

  let storeIds = storeList.map((store) => store.storeId).join(',');
  let endpoint = `${host}${INVENTORY_AVAILABILITY_URL}/${rentalCategory}/${rentalSubCategory}/${storeIds}`;

  const callInventory = async () => {
    const { data, status, statusText } = await axios.get(endpoint);

    if (status !== 200) {
      publishApiToNewRelic(
        {
          action: 'error',
          output: {
            component: 'rental-fulfillment',
            apiName: 'RENTAL-INVENTORY-FORECAST-API',
            baseEndpoint: INVENTORY_AVAILABILITY_URL,
            endpoint,
            storeList,
            rentalCategory,
            rentalSubCategory,
            status,
            statusText,
            data
          }
        }
      );
    } else {
      publishApiToNewRelic(
        {
          action: 'success',
          output: {
            component: 'rental-fulfillment',
            apiName: 'RENTAL-INVENTORY-FORECAST-API',
            baseEndpoint: INVENTORY_AVAILABILITY_URL,
            endpoint,
            storeList,
            rentalCategory,
            rentalSubCategory,
            data
          }
        }
      );
    }
    return data;
  };

  try {
    return await retryCallOnVantageError(callInventory);
  } catch (error) {
    console.error(`Failed when calling ${endpoint}`, error);
    publishApiToNewRelic(
      {
        action: 'error',
        output: {
          component: 'rental-fulfillment',
          apiName: 'RENTAL-INVENTORY-FORECAST-API',
          baseEndpoint: INVENTORY_AVAILABILITY_URL,
          endpoint,
          storeList,
          rentalCategory,
          rentalSubCategory,
          error
        }
      }
    );
    throw new Error('Unexpected Error');
  }
}

export {
  getCurrentInventory
};
